module.exports = __webpack_public_path__ + "img/162.9f9dc486.jpg";